import React from "react";
import { array, bool, string } from "prop-types";

import CustomStoryCard4 from "../../../../molecules/CustomStoryCard4";

import "./organism3.m.css";

const Organism3 = ({ stories, updatedFont, src }) => {
  const firstStory = stories[0].story;
  const secondStory = stories.length > 1 ? stories[1].story : null;

  return (
    stories.length > 0 && (
      <div styleName="base" className="organism3-wrapper">
        <CustomStoryCard4
          story={firstStory}
          headlineType={4}
          showStoryMetaInfo={true}
          className="first-card"
          widths={[120, 220, 300]}
          updatedFont={updatedFont}
          src={src}
        />
        {secondStory && (
          <CustomStoryCard4
            story={secondStory}
            headlineType={16}
            showStoryMetaInfo={true}
            widths={[120]}
            updatedFont={updatedFont}
            src={src}
          />
        )}
      </div>
    )
  );
};

Organism3.propTypes = {
  stories: array.isRequired,
  updatedFont: bool,
  src: string
};

export default Organism3;
